import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

function TerminalCsvComponent({ feature, type = "additional" }) {
  const [open, setOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleClickOpen = (event) => {
    event.stopPropagation();
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleMouseOver = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  /** Helper: pick a reasonable name field automatically */
  const getDisplayName = () => {
    if (!feature) return "Unknown Terminal";

    if (type === "detail") {
      // standardized dataset (blue dots)
      return feature.Name || feature.Terminal_Name || feature.Company || "Unknown Terminal";
    }

    // unstandardized dataset (red dots)
    const nameKeys = [
      "Company",
      "Terminal Name",
      "Terminal_Name",
      "Name",
      "Facility",
      "Operator",
      "Entity",
      "Owner",
      "Operator_Name",
      "Storage Site",
      "Terminal",
      "Facility Name",
      "FACILITY NAME"
    ];

    const key = nameKeys.find(
      k => feature[k] && String(feature[k]).trim().length > 0
    );

    return key ? String(feature[key]).trim() : "Unknown Terminal";
  };

  const renderTooltip = () => <Typography>{getDisplayName()}</Typography>;

  const renderProperties = () => {
    return Object.entries(feature).map(([key, value]) => (
      <Typography key={key}>
        <strong>{key}:</strong> {value !== null ? value : "N/A"}
      </Typography>
    ));
  };

  const getMarkerStyle = () => {
    // color: blue for detail, red for additional
    const backgroundColor = type === "detail" ? "#1E90FF" : "#FF1900";
    return {
      backgroundColor,
      width: isHovered ? "14px" : "7px",
      height: isHovered ? "14px" : "7px",
      display: "inline-block",
      borderRadius: "50%",
      zIndex: 4,
      transition: "width 0.3s, height 0.3s, background-color 0.3s",
      cursor: "pointer",
      border: "1px solid #B9B4B3",
      boxShadow: isHovered ? "0 0 8px rgba(0,0,0,0.3)" : "none",
    };
  };

  return (
    <div>
      <Tooltip title={renderTooltip()}>
        <div
          style={getMarkerStyle()}
          onClick={handleClickOpen}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
        />
      </Tooltip>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{getDisplayName()}</DialogTitle>
        <DialogContent>{renderProperties()}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

function areEqual(prevProps, nextProps) {
  return (
    prevProps.lat === nextProps.lat &&
    prevProps.lng === nextProps.lng &&
    prevProps.feature?.TermControlNo === nextProps.feature?.TermControlNo
  );
}

export default React.memo(TerminalCsvComponent, areEqual);
